<template>
    <ui-modal 
        :icon-circle="true"
        title="Gerar Relatório"
        icon="fal fa-download"
        name="generate-reports"
    >
        <div class="container-generate-reports-modal">
            <span 
                class="container-generate-reports-modal-x"
                @click="closeModal">
                <i class="far fa-times" />
            </span>

            <div class="container-generate-reports-modal-title">
                Gerar Relatório
            </div>

            <div class="container-generate-reports-modal-actions">
                <ui-date-range 
                    groupicon="fal fa-calendar-alt"
                    label="Selecione o período que deseja."
                    size="md" 
                />

                <ui-button 
                    :disabled="true"
                    design="md primary"
                >
                    Gerar relatório
                </ui-button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal } from "@/components/ui/modal"
    import { uiButton } from "@/components/ui/buttons"
    import { uiDateRange } from '@/components/ui/form'

    export default {
        name: 'generate-reports-modal',

        components: {
            uiModal,
            uiButton,
            uiDateRange,
        },

        mounted() {
            this.$root.$on('modal-open-generate-reports')
        },

        beforeDestroy() {
            this.$root.$off('modal-open-generate-reports')
        },

        methods: {
            closeModal() {
                this.$root.$emit('modal-close-generate-reports')
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>